import React from 'react';
import { useSelector } from 'react-redux';
import { Language } from '../../../redux/store/base/language';
import { MDBBtn, MDBCol, MDBContainer, MDBRow } from 'mdbreact';


// Import asset
import "./Services.scss";
import Makeup from "./../../../assets/images/icon/makeup-pink.svg";
import Hairstyle from "./../../../assets/images/icon/hairstyle-pink.svg";
import SPA from "./../../../assets/images/icon/spa-pink.svg";
import NaturalProducts from "./../../../assets/images/icon/natural-products-pink.svg";
import BeautyWaxing from "./../../../assets/images/icon/beauty-waxing-pink.svg";
import Relax from "./../../../assets/images/icon/relax-pink.svg";


const Services = (props: ServicesProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang?.dictionary
    );

    return <MDBRow className="service">
        <MDBCol sm="12">
            <h3 className="text-center mb-1">{dictionary?.link?.services}</h3>
        </MDBCol>
        <MDBCol sm="12">
            <MDBContainer>
                <MDBRow center middle>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={Makeup} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.cosmetic_services}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={Hairstyle} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.hair_services}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={SPA} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.masks}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={NaturalProducts} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.body_services}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={BeautyWaxing} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.skin_services}
                        </MDBBtn>
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={Relax} alt="" />
                        <MDBBtn waves="true" outline>
                            {dictionary?.share?.relaxation_services}
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBCol>
    </MDBRow>
};

interface ServicesProps { }
export default Services;